var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwardCabinetNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "award_cabinet_new_entry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.38,
    y: -0.38,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "award_cabinet_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 300,
    fill: "#ff4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.32,244.55H357.05V159.37a56.19,56.19,0,0,0-56-56h0a56.19,56.19,0,0,0-56,56v85.18H164.83a56.19,56.19,0,0,0-56,56h0a56.19,56.19,0,0,0,56,56H245v85.27a56.2,56.2,0,0,0,56,56h0a56.2,56.2,0,0,0,56-56V356.6h90.27a56.19,56.19,0,0,0,56-56h0A56.19,56.19,0,0,0,447.32,244.55Z",
    fill: "#ffdcd7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardCabinetNewEntry);
export default __webpack_public_path__ + "static/media/award_cabinet_new_entry.10c732144993c14ea3dc9ae71fb8be2c.svg";
export { ForwardRef as ReactComponent };